import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import ThemedTooltip from '../../theme/ThemedTooltip';
import { InfoDark } from '../../globalStyled';
import { fontUi, opticalCenter } from '../../theme/typography';

export const StyledLinksContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  @media screen and (max-width: 1199px) {
    padding: 0 4px;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain;
    box-sizing: border-box;
    scrollbar-width: none;
    &::-webkit-scrollbar {display:none;}
  }
`;
export const StyledNavContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and (max-width: 1199px) {
    flex: 1 0 auto;
    min-width: max-content;
    justify-content: center;
  }
`;
export const StyledNavLink = styled(NavLink)`
  ${fontUi};
  ${opticalCenter};
  padding: 0 20px;
  background: transparent;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.textMuted};
  margin: 0;
  transition: color 0.2s;
  min-width: 0;
  height: 35px;
  @media only screen and (max-width: 1100px) {
    padding: 0 8px;
  }
  @media screen and (max-width: 1199px) {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    box-sizing: border-box;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    justify-content: center;
    text-align: center;
  }

  &:hover {
    color: ${({ theme }) => theme.text};
  }
  &.active-button {
    position: relative;
    color: ${({ theme }) => theme.text};
    font-weight: 600;
    &:before {
      content: '';
      width: 100%;
      bottom: 0;
      border-bottom: 2px solid ${({ theme }) => theme.headerAccent};
      position: absolute;
    }
    @media screen and (max-width: 1199px) {
      color: ${({ theme }) => theme.text};
      &:before {
        left: 8px;
        right: 8px;
        width: auto;
      }
    }
  }
  ${({ disabled, theme }) => {
    if (disabled) {
      return css`
        pointer-events: none;
        color: ${theme.textFaint};
        svg {
          pointer-events: all;
        }
      `;
    }
  }}
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  width: 190px;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledInfoDark = styled(InfoDark)`
  position: absolute;
  right: 35px;
  top: 14px;
  @media only screen and (max-width: 1100px) {
    right: -10px;
  }
`;
export const StyledTabsInfo = styled(InfoDark)`
  position: relative;
  margin-left: 10px;
  @media screen and (max-width: 1199px) {
    display: none;
  }
`;
